import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'

class DetailView extends Component {

    indexBloc = new IndexBloc()
    source
    constructor(props) {
        super(props)
        this.state = {
            detail: []
        }
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/struktur-organisasi.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail Struktur Organisasi</CardTitle>
                            <hr/>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label"
                                >
                                    Nama Struktur Organisasi
                                </Label>
                                <Label
                                    className="col-md-10 col-form-label"
                                >
                                    {detail?.work_unit_name}
                                </Label>
                            </Row>

                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label"
                                >
                                    Parent Struktur Organisasi
                                </Label>
                                <Label
                                    className="col-md-10 col-form-label"
                                >
                                    {detail?.parent ? detail?.parent?.work_unit_name : '-'}
                                </Label>
                            </Row>

                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label"
                                >
                                    Urutan Struktur Organisasi
                                </Label>
                                <Label
                                    className="col-md-10 col-form-label"
                                >
                                    {detail?.work_unit_sort ? detail?.work_unit_sort : '-'}
                                </Label>
                            </Row>

                            {detail?.childs && 
                                <Fragment>
                                    <CardTitle>Children</CardTitle>
                                    <hr/>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>No</th>
                                                <th>Nama Unit</th>
                                                <th>Sort</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detail.childs.map((value, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{value.work_unit_name}</td>
                                                        <td>{value.work_unit_sort ? value.work_unit_sort : '-'}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                </Fragment>
                            }

                        </CardBody>
                    </Card>
                </Container>
            </Fragment>
        )
    }
}

export default DetailView
